import {svgIconWrapper} from '../svg-icon-wrapper';

import VerticalConnector from './vertical-connector-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <VerticalConnector {...props} />;
}

SvgComponent.iconName = 'verticalConnector';

export const VerticalConnectorIcon = svgIconWrapper(SvgComponent);
